var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import SubjectSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/SubjectSelector/SubjectSelector.vue';
import { Group } from '@/models/Group';
import StudentSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/StudentSelector/StudentSelector.vue';
import LabelValue from '@/components/LabelValue.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { AreaSubject } from '@/models/AreaSubject';
import { generateUuid } from '@/support/String';
import { GroupSubject } from '@/models/GroupSubject';
let RemovePlpDialog = class RemovePlpDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.areaSubjects = [];
        this.selectedStudents = {};
        this.selectedSubjects = [];
        this.selectedAll = false;
        this.currentStep = 1;
        this.isLoading = true;
        this.isSelectedAllSubjects = false;
        // #endregion
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Select students'), value: 1 },
                { label: this.$tc('Select PLP'), value: 2 },
            ],
            title: this.$tc('removeDialog.header.title'),
            customButtons: [
                {
                    label: this.$tc('removeDialog.button.removeAll'),
                    action: () => {
                        this.removePlp('all');
                    },
                    visible: this.currentStep === 2,
                    disabled: this.isDisabled,
                    color: 'cancel',
                },
                {
                    label: this.$tc('removeDialog.button.removeInProgress'),
                    action: () => {
                        this.removePlp('highlighted');
                    },
                    visible: this.currentStep === 2,
                    disabled: this.isDisabled,
                    color: 'alert',
                },
                {
                    label: this.$tc('removeDialog.button.removeNew'),
                    action: () => {
                        this.removePlp('busy');
                    },
                    visible: this.currentStep === 2,
                    disabled: this.isDisabled,
                    color: 'primary',
                },
                {
                    label: this.$tc('removeDialog.button.removeOld'),
                    action: () => {
                        this.removePlp('old');
                    },
                    visible: this.currentStep === 2,
                    disabled: this.isDisabled,
                    color: 'secondary',
                },
            ],
        };
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        // await this.fetchSubjects();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onReset() {
        this.selectedStudents = {};
        this.selectedSubjects = [];
        this.selectedAll = false;
        this.currentStep = 1;
        this.isSelectedAllSubjects = false;
    }
    onClose() {
        this.onReset();
        this.$emit('close');
    }
    onSelectedStudents(value) {
        this.$set(this, 'selectedStudents', value);
        console.log('this.selectedStudents: ', this.selectedStudents);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
        if (this.currentStep === 2) {
            this.fetchSubjects();
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchSubjects() {
        if (!Object.keys(this.selectedStudents).length) {
            return;
        }
        if (!this.group || !this.group.id) {
            return;
        }
        this.isLoading = true;
        try {
            if (Object.keys(this.selectedStudents).length === 1) {
                const response = await new AreaSubject().user(Object.keys(this.selectedStudents)[0]).all();
                this.areaSubjects = response.subjects;
                this.areaSubjects.forEach((areaSubject) => {
                    if (areaSubject.groups) {
                        areaSubject.groups.map((group) => {
                            group.id === generateUuid();
                        });
                    }
                    if (areaSubject.periods) {
                        areaSubject.periods.map((period) => {
                            period.id === generateUuid();
                        });
                    }
                });
            }
            else {
                const response = await new AreaSubject().group(this.group.id).all();
                this.areaSubjects = response.subjects;
                this.areaSubjects.forEach((areaSubject) => {
                    if (areaSubject.groups) {
                        areaSubject.groups.map((group) => {
                            group.id === generateUuid();
                        });
                    }
                    if (areaSubject.periods) {
                        areaSubject.periods.map((period) => {
                            period.id === generateUuid();
                        });
                    }
                });
            }
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    async removePlp(subjectStatus) {
        let subjects = [];
        let users = [];
        this.selectedSubjects.forEach((selectedSubject) => {
            subjects = [...selectedSubject.value, ...subjects];
        });
        Object.keys(this.selectedStudents).forEach((selectedStudent) => {
            users = [...[selectedStudent], ...users];
        });
        const payload = {
            subjects,
            users,
            filters: {
                statuses: subjectStatus === 'all' ? ['busy', 'highlighted', 'old'] : [subjectStatus],
            },
            attributes: {
                status: 'inactive',
            },
            select_all: this.selectedAll,
        };
        try {
            await new GroupSubject().updateMass(this.group.id, payload);
            this.onReset();
            this.$emit('submitted');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return (Object.keys(this.selectedStudents).every((key) => {
                    return this.selectedStudents[key] === false;
                }) || Object.keys(this.selectedStudents).length === 0);
            case 2:
                return this.selectedSubjects.length === 0 && !this.selectedAll;
            default:
                return false;
        }
    }
    // #endregion
    // #region @Watchers
    onIsSelectedAllSubjectsChanged(value) {
        this.selectedAll = value;
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], RemovePlpDialog.prototype, "group", void 0);
__decorate([
    Watch('isSelectedAllSubjects'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RemovePlpDialog.prototype, "onIsSelectedAllSubjectsChanged", null);
RemovePlpDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            SubjectSelector,
            StudentSelector,
            LabelValue,
        },
    })
], RemovePlpDialog);
export default RemovePlpDialog;
// #endregion
// #region Constants
// #endregion
